import { render, staticRenderFns } from "./PartnerMallSelectBox.vue?vue&type=template&id=47120905&"
import script from "./PartnerMallSelectBox.vue?vue&type=script&lang=ts&"
export * from "./PartnerMallSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports